import {useEffect, useRef} from "react";

function usePrevious(value) {
    const ref = useRef()

    useEffect(() => {
        ref.current = value
    },[value]) //this code will run when the value changes
    return ref.current //in the end, return the current value.
}
export default usePrevious